<div class="panel content-m dropdown-shadow white-bg radius-m">
    <!-- <ul #list id="list" *ngIf="dataType =='object'">
        <li [style]="style" *ngFor="let item of data;let i = index" tabindex="-1" (keydown)="onKeyDown($event,i)"
            (click)="onClick(item[displayColumn], i)">
            <input *ngIf="DropDown.MULTISELECT" type='checkbox' name='checkList' id="{{'chk'+i }}"
                (click)="$event.stopPropagation">
            {{item[displayColumn]}}
        </li> -->
    <!-- [checked]="item['checked']" -->
    <!-- </ul>
     <ul #list id="list" *ngIf="dataType !='object'"> -->
    <div *ngIf="isSearch" class="custom-search pl-3">
        <img class="icon-s" src="assets/search-small.svg">
        <input class="input-border" type="search" placeholder="Search" [formControl]="searchValue">
    </div>
    <ul #list id="list" class="p-0 m-0">
        <li class="primary-text p-3 m-0" [style]="style" *ngFor="let item of data;let i = index" tabindex="-1" (keydown)="onKeyDown($event,i)" (click)="onClick(item, i)" [ngClass]="status && status[i] == 0?'permission-denied':'enable-action'">
            <!-- <input *ngIf="DropDown.MULTISELECT" type='checkbox' name='checkList' id="{{'chk'+i }}" (click)="check(i)"> {{item}}-->
            <ng-container *ngIf="DropDown.MULTISELECT">
                <label class="checkbox-container content-m pl-8"> {{item}}
                    <input type="checkbox" name='checkList' id="{{'chk'+i }}">
                    <span class="checkmark white-bg radius-m "></span>
                </label>
            </ng-container>
            <ng-container *ngIf=" !DropDown.MULTISELECT">
                {{item}}

            </ng-container>
        </li>
        <li *ngIf="data.length == 0">
            no result
        </li>
    </ul>
</div>